export default __webpack_public_path__ + "static/media/stars.6dc00c9f.gif";